"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaults = {};

var SSE = function () {
  function SSE(url) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    _classCallCheck(this, SSE);

    this.es = new window.EventSource(url, _extends({}, defaults, { options: options }));
  }

  _createClass(SSE, [{
    key: "on",
    value: function on(type, fn) {
      this.es.addEventListener(type, function (e) {
        if (e.data) fn(JSON.parse(e.data));
      });
    }
  }, {
    key: "close",
    value: function close() {
      this.es.close();
    }
  }]);

  return SSE;
}();

exports.default = SSE;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7QUFDQSxJQUFNLFdBQVcsRUFBakI7O0lBRXFCLEc7QUFDbkIsZUFBYSxHQUFiLEVBQWdDO0FBQUEsUUFBZCxPQUFjLHlEQUFKLEVBQUk7O0FBQUE7O0FBQzlCLFNBQUssRUFBTCxHQUFVLElBQUksT0FBTyxXQUFYLENBQXVCLEdBQXZCLGVBQWlDLFFBQWpDLElBQTJDLGdCQUEzQyxJQUFWO0FBQ0Q7Ozs7dUJBRUcsSSxFQUFNLEUsRUFBSTtBQUNaLFdBQUssRUFBTCxDQUFRLGdCQUFSLENBQXlCLElBQXpCLEVBQStCLGFBQUs7QUFDbEMsWUFBSSxFQUFFLElBQU4sRUFBWSxHQUFHLEtBQUssS0FBTCxDQUFXLEVBQUUsSUFBYixDQUFIO0FBQ2IsT0FGRDtBQUdEOzs7NEJBRVE7QUFDUCxXQUFLLEVBQUwsQ0FBUSxLQUFSO0FBQ0Q7Ozs7OztrQkFia0IsRyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbIlxuY29uc3QgZGVmYXVsdHMgPSB7fVxuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBTU0Uge1xuICBjb25zdHJ1Y3RvciAodXJsLCBvcHRpb25zID0ge30pIHtcbiAgICB0aGlzLmVzID0gbmV3IHdpbmRvdy5FdmVudFNvdXJjZSh1cmwsIHsgLi4uZGVmYXVsdHMsIG9wdGlvbnMgfSlcbiAgfVxuXG4gIG9uICh0eXBlLCBmbikge1xuICAgIHRoaXMuZXMuYWRkRXZlbnRMaXN0ZW5lcih0eXBlLCBlID0+IHtcbiAgICAgIGlmIChlLmRhdGEpIGZuKEpTT04ucGFyc2UoZS5kYXRhKSlcbiAgICB9KVxuICB9XG5cbiAgY2xvc2UgKCkge1xuICAgIHRoaXMuZXMuY2xvc2UoKVxuICB9XG59XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ../~/@segment/sse.js/lib/index.js
// module id = 598
// module chunks = 0